/**
 * Shipping y Proforma del pago son listas de referencias, pero en datos viejos (o mientras
 * no corrió la migración) llegan sueltos. Devuelve siempre una lista, sin vacíos.
 */
export function refArray(value) {
  const list = Array.isArray(value) ? value : value ? [value] : [];
  return list.filter((v) => v != null && v !== "");
}

/** El primer elemento de refArray, o null. */
export function firstRef(value) {
  return refArray(value)[0] || null;
}

/** Nombres de una referencia poblada (suelta o lista), separados por coma. */
export function refNames(value) {
  return refArray(value)
    .map((v) => (v && typeof v === "object" ? v.name : ""))
    .filter(Boolean)
    .join(", ");
}
